import {
  LegalEntitiesUpdateRequestType,
  LegalEntitiesUpdateResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";
import { useLegalEntityId } from "./useLegalEntityId";

export const useLegalEntityUpdate = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();
  const legalEntityId = useLegalEntityId();

  return useMutation({
    mutationFn: async (data: LegalEntitiesUpdateRequestType) => {
      if (!legalEntityId) {
        throw new Error("Cannot update legal entity missing legalEntityId");
      }

      return apiV2Request({
        user,
        business,
        method: "put",
        path: `legal-entity/${legalEntityId}`,
        data,
      }).then(
        (response) =>
          apiV2AssertResponse(response).data as LegalEntitiesUpdateResponseType,
      );
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        predicate: ({ queryKey }) =>
          queryKey[0] === user?.uid &&
          (queryKey[2] === ServerStateKeys.LegalEntity ||
            queryKey[2] === ServerStateKeys.Businesses),
      });
    },
  });
};
